import { Component, Input } from '@angular/core';
import { Observable, from, defer } from 'rxjs';

import { ApiCallCachingService } from '../../services/api-call-caching.service';
import { ReturnTypesService } from '../../services/return-types.service';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';

@Component({
  selector: 'spv2-return-type-dropdown',
  templateUrl: './dropdown-base/dropdown-base.component.html',
  styleUrls:['./dropdown-base/dropdown-base.component.scss']
})
export class ReturnTypeDropdownComponent extends DropdownBaseComponent<string, string> {

  private _searchString : string;

  @Input() public set searchString(v : string) {
    this._searchString = v;
    if(this.value) {
      this.value = null;
      this.valueChange.emit(this.value);
    }
    this.debounceTrigger.execute(null);
  }

  get uniqueName() {
    return "returnTypes" + this._searchString;
  } 

  textField = null; //we are not using a complex object
  valueField = null;

  enableCache = false;
  loadDataAutomatically = false;

  dataFunction = () => this.getFilteredReturnTypes();

  //workaround mocking observable
  getFilteredReturnTypes(): Observable<string[]> { 
    if(!this._searchString){
      console.log("getting all return types")
      return this.returnTypesService.getAllReturnTypes()
    }

    let filteredOutArray : string[] = []
    
    this.returnTypesService.getReturnAndCredentialTypes(this._searchString).subscribe(e => {
      console.log(e)
      e.returnTypes.forEach(returnType =>{
        filteredOutArray.push(returnType.code)
      })
    });
        
    const mockedResponse = new Observable<string[]>( observer => {
      observer.next( filteredOutArray )
 
      observer.complete()
   })
    return mockedResponse;
  }


  constructor(private returnTypesService: ReturnTypesService, cachingService: ApiCallCachingService) {
    super(cachingService);
  }



}
